export default {
  SET_REFERRAL_DATA(state, referralData) {
    state.referrals = referralData;
  },
  SET_REFERRAL_RECORDS(state, totalReferrals) {
    state.totalReferrals = totalReferrals;
  },
  SET_CURRENT_PAGE(state, data) {
    state.referrals.currentPage = data;
  },
};
